import { render, staticRenderFns } from "./DPZS.vue?vue&type=template&id=b667005c&"
import script from "./DPZS.vue?vue&type=script&lang=js&"
export * from "./DPZS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports